<template>
  <div>
    <amio-chat v-if="selectedPlatform === 'amio_chat'"></amio-chat>
    <facebook-messenger v-else-if="selectedPlatform === 'facebook_messenger'"></facebook-messenger>
    <mobile v-else-if="selectedPlatform === 'mobile'"></mobile>
    <rbm v-else-if="selectedPlatform === 'rbm'"></rbm>
    <telegram v-else-if="selectedPlatform === 'telegram'"></telegram>
    <viber v-else-if="isViber"></viber>
    <whatsapp v-else-if="selectedPlatform === 'whatsapp'"></whatsapp>
    <div v-else="" class="alert alert-danger">
      Unsupported platform
    </div>
  </div>
</template>

<script>
  import FacebookMessengerWizard from './facebook-messenger/FacebookMessengerWizard'
  import ViberTypeSelector from './viber/ViberTypeSelector'
  import MessageBirdWizard from './mobile/MessageBirdWizard'
  import RbmWizard from './rbm/RbmWizard'
  import AmioChatWizard from './amio-chat/AmioChatWizard'
  import TelegramWizard from './telegram/TelegramWizard'
  import WhatsappWizard from './whatsapp/WhatsappWizard'
  import contains from 'ramda/src/contains'

  export default {
    components: {
      'amio-chat': AmioChatWizard,
      'facebook-messenger': FacebookMessengerWizard,
      'mobile': MessageBirdWizard,
      'rbm': RbmWizard,
      'telegram': TelegramWizard,
      'viber': ViberTypeSelector,
      'whatsapp': WhatsappWizard
    },

    data() {
      return {
        selectedPlatform: this.$route.query.platform
      }
    },

    computed: {
      isViber() {
        return contains(this.selectedPlatform, ['viber', 'viber_business', 'viber_bot'])
      }
    }
  }
</script>
